import React from "react";
import {
  SMALL_VIEWPORT,
  LARGE_VIEWPORT,
  MEDIUM_VIEWPORT
} from "@template/state/modules/layout/";
import MiscBar from "@template/components/MiscBar";
import Header from "@template/components/Header";
import LargeNavigation from "@template/components/Navigation/LargeNavigation";
import SidePanel from "@template/components/Navigation/SidePanel";
import CookieDisclaimer from "@template/components/Header/CookieDisclaimer";
import UnsupportedBrowser from "@template/components/UnsupportedBrowserMessage";
import LayoutManager from "@template/components/LayoutManager";
import NotQuiteStickyHeader from "@template/components/NotQuiteStickyHeader";
import GlobalBanner from "@template/components/GlobalBanner";
import GDPR from "@template/components/GDPR";
import SkipToContent from "@template/components/Header/SkipToContent";
import CountrySelector from "@template/components/CountrySelector";
import NativeAppBanner from "../NativeAppBanner";
import "./HtmlHeader.css";

const HtmlHeader = () => (
  <header>
    <LayoutManager />
    <SkipToContent />
    <CookieDisclaimer />
    <UnsupportedBrowser />
    <MiscBar viewable={[LARGE_VIEWPORT]} />
    <NotQuiteStickyHeader>
      <Header />
      <LargeNavigation viewable={[LARGE_VIEWPORT]} />
    </NotQuiteStickyHeader>
    <SidePanel viewable={[SMALL_VIEWPORT, MEDIUM_VIEWPORT]} />
    <GDPR />
    <GlobalBanner viewable={[MEDIUM_VIEWPORT, LARGE_VIEWPORT]} />
    <CountrySelector />
    <NativeAppBanner />
  </header>
);

export default HtmlHeader;
